/*------------------------------------*\
    MODULES
\*------------------------------------*/
import { Timeline } from "../helpers/timelinejs";
import 'whatwg-fetch';

/*------------------------------------*\
    TIMELINE
\*------------------------------------*/
class MyTimeline {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.elemId = self.elem.getAttribute('id');
    }

    init() {
        let self = this;

        fetch('/api/timeline.json')
            .then(function (response) {
                return response.json();
            }).then(function (json) {
                // Init the timeline
                self.initTimeline(json);
            }).catch(function (ex) {
                console.log('Parsing failed', ex);
            });
    }

    initTimeline(json) {
        let self = this;

        const timelineOptions = {
            initial_zoom: 2,
            timenav_position: 'top',
            marker_height_min: 25,
            start_at_end: true
        }

        timeline = new Timeline(self.elemId, json, timelineOptions);
    }
}

export default MyTimeline;
